module.exports = __webpack_public_path__ + "img/CEV2501.73021915.png";